document.addEventListener("DOMContentLoaded", () => {
    const slider = document.querySelector(".product__media-list");
    const shareButton = document.querySelector(".share-engine-button");

    if (!slider || !shareButton || slider.children.length <= 1) return;

    function updateSliderPadding() {
        const scrollableWidth = slider.scrollWidth - slider.clientWidth;
        const scrollLeft = slider.scrollLeft;
        const threshold = 5;
        const nearEnd = scrollLeft + threshold >= scrollableWidth;

        // ✅ Optimized class toggling
        slider.classList.toggle("slider-padding-right", !nearEnd);
        slider.classList.toggle("slider-padding-left", nearEnd);
        shareButton.classList.toggle("shareatfirstmedia", nearEnd);
        shareButton.classList.toggle("shareatlatsmedia", !nearEnd);
    }

    // ✅ Run on relevant events
    ["load", "scroll", "resize"].forEach(event => window.addEventListener(event, updateSliderPadding));
    slider.addEventListener("scroll", updateSliderPadding);
});
